export default {
    url: 'solutions',
    include: ['us', 'jp', 'ca', 'uk', 'cn', 'za', 'au', 'de', 'fr', 'sa', 'eu'],
};
